import { replace as _replace } from "lodash";
import { useState, useEffect } from "react";

export default function DynamicTextFormatter(props) {
  const { textString, values, style } = props;
  const [stringArr, setStringArr] = useState([]);


  useEffect(() => {
    const newString = _replace(textString, /__\w+__/g, function (match) {
      return `,${match},`;
    });
    const newStringArray = newString.split(",");
    setStringArr(newStringArray);
  }, [textString]);


  return (
    <p style={style}>
      {stringArr.map((str) => {
        if (values[str]) {
          return <span style={values[str].style}>{values[str].value}</span>;
        }
        return str;
      })}
    </p>
  );
}
